import React from 'react';
import { ModuleHealthCheck } from '../components/ModuleHealthCheck';

const SystemHealthCheckPage: React.FC = () => {
  return <ModuleHealthCheck />;
};

export default SystemHealthCheckPage;